import { ControlButton } from '@xyflow/react';
import { memo, useCallback } from 'react';
import { cn } from '../../../helpers/util';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { selectMoving, setMoving } from '../../../redux/slices/diagram';
import GraphIcon from './icons/graph-icon.component';

const MoveNodesControl = memo(function MoveNodesControl() {
  const isMoving = useAppSelector(selectMoving);
  const dispatch = useAppDispatch();

  const handleClick = useCallback(() => {
    dispatch(setMoving(!isMoving));
  }, [dispatch, isMoving]);

  return (
    <ControlButton
      data-cy="toggle-arrange-nodes-button"
      title="Toggle arrange nodes"
      className={cn({ 'bg-border': isMoving })}
      onClick={handleClick}
    >
      <GraphIcon />
    </ControlButton>
  );
});

export default memo(MoveNodesControl);
